import { render, staticRenderFns } from "./report-modal.vue?vue&type=template&id=fd6d1a54"
import script from "./report-modal.vue?vue&type=script&lang=js"
export * from "./report-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports